<template>
  <a-spin :spinning="confirmLoading">
    <div class="upload-imgs-files">
      <a-modal
        :visible="previewVisible"
        :footer="null"
        :width="800"
        @cancel="closeBig"
      >
        <img alt="example" style="width: 100%" :src="bigImage" />
      </a-modal>
      <div class="defaultImg-nav" v-if="previewImage.length && type == 'img'">
        <div
          class="defaultImg"
          v-for="(item, index) in previewImage"
          :key="index"
        >
          <span @click="deleteImg(index)"><a-icon type="close"/></span>
          <div class="defaultImg-cont">
            <img
              alt="example"
              :src="item.access_url"
              @click="hanldeImg(item)"
            />
          </div>
        </div>
      </div>
      <div class="defaultImg-nav" v-if="!previewImage.length && type == 'img'">
        <div class="defaultImg">
          <a-icon type="picture" theme="twoTone" />
        </div>
      </div>
      <div class="defaultImg-nav" v-if="previewImage.length && type == 'file'">
        <div
          class="default-File"
          v-for="(item, index) in previewImage"
          :key="index"
        >
          <p>{{ item.name }}</p>
          <span @click="deleteImg(index)"><a-icon type="delete" />删除</span>
        </div>
      </div>
      <div class="upload-btn">
        <a-upload
          class="upload-btn-u"
          :showUploadList="false"
          :customRequest="handleUpload"
          :beforeUpload="beforeUpload"
        >
          <div class="upload-btn-btn">
            <a-button type="primary" class="btn-blue" icon="cloud-upload">
              {{ uploadTitle }}
            </a-button>
          </div>
        </a-upload>
      </div>
    </div>
  </a-spin>
</template>
<script>
export default {
  props: {
    uploadTitle: {
      type: String,
      default: "上传",
    },
    fileType: {
      type: Array,
      default: () => [],
    },
    businessType: {
      type: String,
      default: "",
    },
    defaultFile: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: "file",
    },
    maxCount: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      confirmLoading: false,
      previewVisible: false,
      bigImage: "",
    };
  },
  computed: {
    previewImage() {
      return this.defaultFile || [];
    },
  },
  methods: {
    closeBig() {
      this.previewVisible = false;
    },
    hanldeImg(data) {
      this.bigImage = data.access_url;
      this.previewVisible = true;
    },
    // 上传返回
    handleUpload(data) {
      this.confirmLoading = true;
      this.common.fileUpload(data, this.businessType).then(res => {
        const newD = JSON.parse(JSON.stringify(this.previewImage));
        if (this.maxCount == 1) {
          this.back([res]);
        } else {
          newD.push(res);
          this.back(newD);
        }
        this.confirmLoading = false;
      });
    },
    beforeUpload(file) {
      if (this.maxCount && this.maxCount > 0) {
        if (this.previewImage.length >= this.maxCount) {
          this.pubMsg.tipMessage(`最多上传${this.maxCount}个文件`);
          return false;
        }
      }
      if (this.fileType.length) {
        return this.common.beforeUpload(file, this.fileType);
      }
    },
    // 删除
    deleteImg(index) {
      const newD = JSON.parse(JSON.stringify(this.previewImage));
      newD.splice(index, 1);
      this.back(newD);
    },
    back(data) {
      this.$emit("uploadOk", data);
    },
  },
};
</script>
<style lang="less">
.upload-imgs-files {
  &::after {
    content: "";
    display: block;
    clear: both;
    height: 0;
  }
  .defaultImg-nav {
    &::after {
      content: "";
      display: block;
      clear: both;
      height: 0;
    }
    .defaultImg {
      float: left;
      padding: 5px;
      width: 90px;
      height: 90px;
      display: flex;
      border: 1px solid @border-color;
      justify-content: center;
      align-items: center;
      position: relative;
      background-color: #fff;
      margin-right: 10px;
      margin-bottom: 10px;
      .defaultImg-cont {
        width: 80px;
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        overflow: hidden;
      }
      i {
        font-size: 60px;
      }
      span {
        display: block;
        width: 20px;
        height: 20px;
        position: absolute;
        cursor: pointer;
        top: -5px;
        right: -5px;
        background: @red;
        border-radius: 50%;
        line-height: 20px;
        text-align: center;
        z-index: 2;
        i {
          color: #fff;
          font-size: 14px;
        }
      }
    }
    .defaultImg:hover {
      opacity: 0.8;
    }
    .default-File {
      border: 1px solid @border-color;
      border-radius: 3px;
      margin: 5px 0;
      background: #fff;
      line-height: 30px;
      display: flex;
      padding: 0 15px;
      &:hover {
        background-color: #f8f8f8;
      }
      p {
        flex: 1;
        margin: 0;
        overflow: hidden;
        -ms-text-overflow: ellipsis;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span {
        display: block;
        cursor: pointer;
      }
    }
  }
  .upload-btn {
    .upload-btn-u1 {
      width: 100%;
      display: block;
      .ant-upload {
        display: block !important;
        width: 100%;
        .upload-btn-btn {
          width: 100%;
          height: 34px;
          line-height: 34px;
          padding: 0 10px;
          background: @blue;
          text-align: center;
          color: #fff;
          cursor: pointer;
          i {
            margin-right: 3px;
          }
          &:hover {
            background: #66c0ec;
            border-color: #66c0ec;
          }
        }
      }
    }
  }
}
</style>
